export const deClientPortalAnalysisPages = {
    analysis: {
        analysisPage: {
            metrics: {
                totalSelectedAssetsMarketValue: 'Gesamtmarktwert ausgewählter Immobilien',
                totalSelectedAssetsMarketRent: 'Gesamtmarktmiete ausgewählter Immobilien',
                selectedAssetsValueTrend: 'Marktwertentwicklung ausgewählter Immobilien',
                selectedAssetsRentTrend: 'Entwicklung Marktmiete ausgewählter Immobilien',
            },
            marketValueTrendTooltip:
                'Die Entwicklung vergleicht den aktuellen Gesamtmarktwert mit der Summe der Marktwerte aus der jeweils vorherigen Bewertung der ausgewählten Immobilien. Immobilien, deren vorherige Bewertung keinen Marktwert enthält, werden nur im aktuellen Gesamtwert berücksichtigt. Sie bleibt unabhängig vom gewählten Diagrammzeitraum.',
            marketRentTrendTooltip:
                'Die Entwicklung vergleicht die aktuelle Gesamtmarktmiete mit der Summe der Marktmieten aus der jeweils vorherigen Bewertung der ausgewählten Immobilien. Immobilien, deren vorherige Bewertung keine Marktmiete enthält, werden nur in der aktuellen Gesamtmarktmiete berücksichtigt. Sie bleibt unabhängig vom gewählten Diagrammzeitraum.',
            metricTabsAriaLabel: 'Analysekennzahl',
            selectedAssetsMarketValueDevelopment: 'Entwicklung Marktwert ausgewählter Immobilien',
            selectedAssetsMarketRentDevelopment: 'Entwicklung Marktmiete ausgewählter Immobilien',
            summarySeriesLabel: 'Gesamt',
        },
    },
}
